export const environment = {
  production: true,
  development: false,
  test: false,
  brand: 'HM',
  apiConfig: {
    scopes: ['api://boiard-prd-back-office/Read.All', 'api://boiard-prd-back-office/Write.All'],
    uri: 'https://assurance.vyv-conseil.fr/api/',
  },
  keycloak: {
    url: 'https://authentification.harmonie-mutuelle.fr/auth',
    realm: 'adherents',
    clientId: 'vyvconseil',
    tokenEndpoint: 'authentication/token/hm',
  },
  passConnect: {
    url: 'https://passconnect.groupe-vyv.fr/auth',
    realm: 'passconnect',
    clientId: 'sequoia-adherent',
    tokenEndpoint: 'authentication/token/passconnect',
  },
  appInsightsConfig: {
    connectionString: 'InstrumentationKey=4b3dcc26-4751-41e6-8b52-328d2684a113;IngestionEndpoint=https://francecentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://francecentral.livediagnostics.monitor.azure.com/;ApplicationId=96f63e11-b3cc-4386-b041-c9b2249d4cd3',
    maxBatchIntervalMs: '15000',
  },
  ParcoursDeSouscription: {
    AHC: 'https://assurance-habitation.vyv-conseil.fr/product/HC',
    AHP: 'https://assurance-habitation.vyv-conseil.fr/product/HP',
    AHS: 'https://assurance-habitation.vyv-conseil.fr/product/HS',
    AHT: 'https://assurance-habitation.vyv-conseil.fr/product/HT',
  },
  EspaceAdherentUrl: {
    MGEN: "https://www.mgen.fr/login-adherent/",
    HM: "https://harmonie-et-moi.fr/",
    MNT: "https://adherents.mnt.fr/"
  },
  Systempay: {
    endpoint: 'https://api.systempay.fr',
    publicKey: '73852400:publickey_TtUXdePNYGWiUYyqhwpQoplsqqDw8XnPG1H4xati9RWpB',
  },
   msalConfig: {
    auth: {
      clientId: 'a534f16e-c6bf-4f73-99dc-787d1d3e4530',
      authority: 'https://login.microsoftonline.com/6f12f368-4cb1-4b07-9574-dd2cdf95d9c1',
    },
    enabled: 'true',
  },
};
